define('common/views/message_view',['require','exports','module','base/view','ldsh!../templates/message'],function(require, exports, module) {
  "use strict";

  var View = require("base/view");

  module.exports = View.extend({
    template: require("ldsh!../templates/message"),
    helpers: function() {
      return this.options;
    },
    onRender: function() {
      this.$el.i18n();
    }
  });

});

